import { assets } from '@/ui/assets'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { testIds } from '@/ui/utils/testIds'
import { cn } from '@/ui/utils/style'
import { LinkButton } from '@/ui/atoms/button/Button'
import { paths } from '@/config/paths'
import { SPK_MOCK_TOKEN } from '@/domain/types/Token'
import Image from 'next/image'
import { useUserPoints as useUserSeasonMewPoints } from '@/features/points/logic/seasonMew/useUserPoints'
import { NormalizedUnitNumber } from '@/domain/types/NumericValues'
import { navWalletButtonStyles } from '../wallet-button/ConnectButton'

interface PointsBadgeProps {
  className?: string
  closeMobileMenu?: () => void
}

export function PointsBadge({ className, closeMobileMenu }: PointsBadgeProps) {
  const { data: userSeasonMewPoints, isLoading: isLoadingSeasonMewPoints } = useUserSeasonMewPoints()
  const userPoints = NormalizedUnitNumber(userSeasonMewPoints?.total_amount ?? 0)
  const isPointsLoading = isLoadingSeasonMewPoints

  return (
    <div>
      <LinkButton
        href={paths.points}
        className={cn(navWalletButtonStyles(), className)}
        data-testid={testIds.navbar.airdropBadge}
        onClick={closeMobileMenu}
      >
        <span className="flex items-center justify-center gap-1.5">
          <Image src={assets.hypurrPaw} alt="hypurr paw" className="block h-6 w-auto pt-1" />
          {isPointsLoading ? (
            <Skeleton className="h-4 w-12" />
          ) : (
            <span className="flex items-center font-bold text-foreground text-xs" data-chromatic="ignore">
              {SPK_MOCK_TOKEN.format(userPoints, { style: 'compact', fractionDigits: userPoints.gt(10000) ? 1 : 2 })}{' '}
              Points
            </span>
          )}
        </span>
      </LinkButton>
    </div>
  )
}
